import cn from "classnames";

import { Typography } from "shared/ui/components/Typography";

import styles from "./IrrCard.module.scss";

const IrrCard = ({ irrConclusion, irr }: { irrConclusion: any, irr: number }) => {
  return (
    <div className={styles.chartItem}>
      <Typography
        className={styles.chartTitle}
        variant="bodyS"
        weight="semiBold"
        withHTML
      >
        {irrConclusion.title}
      </Typography>

      <Typography
        className={cn([
          {
            [styles.chartTitlePositive]: irr   > 10,
            [styles.chartTitleNeutral]: irr >= 7 && irr <= 10,
            [styles.chartTitleNegative]: irr < 7,
          },
        ])}
        variant="bodyM"
        weight="semiBold"
        withHTML
      >
        {irrConclusion.value}
      </Typography>

      <Typography variant="bodyXS" className={styles.chartDescription}>
        {irrConclusion.description}
      </Typography>
    </div>
  );
};

export default IrrCard;
